import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

export function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  const dark = theme === "dark";
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="theme-toggle"
      title={dark ? "Tema claro" : "Tema oscuro"}
      aria-label={dark ? "Activar tema claro" : "Activar tema oscuro"}
      className={`inline-flex items-center justify-center w-9 h-9 rounded-md border border-[#D5E7E5] bg-white text-[#075E62] hover:text-[#0299A0] transition-colors duration-150 ${className}`}
    >
      {dark ? <Sun size={16} strokeWidth={1.9} /> : <Moon size={16} strokeWidth={1.9} />}
    </button>
  );
}
